import { render } from "./AdminBox.vue?vue&type=template&id=1ba85b17&scoped=true"
import script from "./AdminBox.vue?vue&type=script&lang=js"
export * from "./AdminBox.vue?vue&type=script&lang=js"

import "./AdminBox.vue?vue&type=style&index=0&id=1ba85b17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba85b17"]])

export default __exports__